import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { ConfirmAlertDialog } from "../../../components/common/ConfirmAlertDialog";
import { Lists } from "../../../components/common/Lists";
import TableComponent from "../../../components/common/Tables";
import { useAppDispatch } from "../../../hooks/hooks";
import { useGetProjectsQuery } from "../../../hooks/scientific/useGetProjectsQuery";
import { routes } from "../../../routes";
import { ProjectType } from "../../../types/ScientificModule";
import { Key_projects } from "../../../utils/constants";
import { updateProject } from "../../../services/scientific/project";
import { setProjectsData } from "../../../redux/slices/scientific/projects";
import { Badge } from "@radix-ui/themes";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { useGetJudgeExhibitorByUserIdQuery } from "../../../hooks/scientific/useGetJudgeExhibitorByUserIdQuery";
import { useGetExhibitorsProjectsQuery } from "../../../hooks/scientific/useGetExhibitorsProjectsQuery";

const columnNamesMap: { [key: string]: string } = {
  description: 'Descrição',
  currentPhase: 'Fase actual',
  startdate: 'Data de Início',
  icon:"Terminado?"
};

export const MyProjectsAsExhbitors = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const userLogged = useSelector((state: RootState) => state.login.userData);
  const { data:judgeOrExhibitor } = useGetJudgeExhibitorByUserIdQuery(userLogged.UserId, {
    enabled: !!userLogged.UserId
})

  

  const { data, status } = useGetProjectsQuery({ PageNumber: currentPage, PageSize: 400 });
  const exhibitorsProjects = useGetExhibitorsProjectsQuery({ PageNumber: currentPage, PageSize: 400 },{
    enabled: !!judgeOrExhibitor?.idExhibitor
  });
  const projects_by_exhibitor = data?.items.filter(p => exhibitorsProjects.data?.items.map(ep=> ep.idProject).includes(p.id!))
  const [deleteItem, setDeleteItem] = useState<ProjectType | null>(null);
  const [startProjectitem, setStartProjectitem] = useState<ProjectType | null>(null);

  const mutationUpdate = useMutation(updateProject, {
    onSuccess: () => {
      queryClient.invalidateQueries(Key_projects);
      toast.success('Projeto atualizado com sucesso');
    },
    onError: () => {
      toast.error("Erro ao atualizar o Projeto.");
    }
  });

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handleClickCreate = () => {
    navigate(routes.createProject);
  };

  const handleEdit = (c: ProjectType) => {
    c.icon = '';
    dispatch(setProjectsData(c));
    navigate(routes.updateProject);
  };

  const handleDelete = (c: ProjectType) => {
    c.status = false;
    mutationUpdate.mutateAsync(c);
  };

  const openDeleteDialog = (s: ProjectType) => {
    setDeleteItem(s);
  };
  const openStartProjectDialog = (s: ProjectType) => {
    setStartProjectitem(s);
  };

  const confirmDelete = async () => {
    if (deleteItem) {
      await handleDelete(deleteItem);
    }
  };
  const confirmStartProject = async () => {
    if (startProjectitem) {
     // await handleStartProject(startProjectitem);
    }
  };

  const options = data?.items.map((c: ProjectType) => [
    {
      label: 'Editar',
      onClick: () => handleEdit(c),
      icon: <Pencil1Icon />
    },
    {
      label: 'Eliminar',
      onClick: () => openDeleteDialog(c),
      icon: <TrashIcon />
    }
  ]) || [];

    useEffect(() => {
        if (!judgeOrExhibitor?.idExhibitor) {
            navigate(routes.projects)
        }
    }, [])

  return (
    <>
      <Lists
        status={status}
        TableComponent={() =>
          <TableComponent
            columns={Object.keys(columnNamesMap)}
            items={projects_by_exhibitor?.map(i=> {
              return {...i,
                  icon: i.isEnded? <Badge color="green"> Terminado</Badge>: <Badge color="gray"> Não Terminado</Badge> 
              }
            })}
            options={options}
            columnNamesMap={columnNamesMap}
            totalPages={data?.totalPages || 1}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            emptyMessage="Ainda não existem projectos associados a si."
          />
        }
        handleClickCreate={handleClickCreate}
      />
      <ConfirmAlertDialog
        open={!!deleteItem}
        onOpenChange={(open) => !open && setDeleteItem(null)}
        title="Esta operação é irreversível"
        description="O projecto deixará de estar disponível. Pretende continuar?"
        confirmLabel="Eliminar"
        item={deleteItem}
        onConfirm={confirmDelete}
        onCancel={() => setDeleteItem(null)}
      />
      <ConfirmAlertDialog
        open={!!startProjectitem}
        onOpenChange={(open) => !open && setStartProjectitem(null)}
        title="Esta operação é irreversível"
        description="O projecto será iniciado na primeira fase definida. Pretende continuar?"
        confirmLabel="Iniciar"
        confirmColor="green"
        item={startProjectitem}
        onConfirm={confirmStartProject}
        onCancel={() => setStartProjectitem(null)}
      />
    </>
  );
};
